import axios from '@/axiosInterceptor';
// const state = () => ({})

// getters
// const getters = {}

// actions
const actions = {
  async createPhone(_, { carrierId, value, isType, onboardingPackeId }) {
    let body = {
      phone: {
        carrier_id: carrierId,
        value: value,
        is_type: isType,
        phoneable_type: 'OnboardingPacket',
        phoneable_id: onboardingPackeId,
      },
    };
    try {
      let res = await axios.post(
        `${process.env.API_MONITOR}/api/v1/phones`,
        body
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async updatePhone(_, { id, carrierId, value, isType }) {
    let body = {
      phone: {
        carrier_id: carrierId,
        value: value,
        is_type: isType,
      },
    };
    try {
      let res = await axios.patch(
        `${process.env.API_MONITOR}/api/v1/phones/${id}`,
        body
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
  async deletePhone(_, id) {
    try {
      let res = await axios.delete(
        `${process.env.API_MONITOR}/api/v1/phones/${id}`
      );
      return res;
    } catch (e) {
      handleAxiosError(e);
    }
  },
};

function handleAxiosError(e) {
  const status = e.response?.status;
  if (
    axios.isAxiosError(e) &&
    status &&
    [401, 403, 404, 422].includes(status)
  ) {
    return e.response;
  } else {
    throw e;
  }
}

// const mutations = {}

export default {
  namespaced: true,
  // state,
  // getters,
  actions,
  // mutations,
};
